export default __webpack_public_path__ + "static/media/photo-test2.bbcdb6b5.jpg";